import React from 'react';

import { StyledKeywords } from './style/StyledKeywords';

import NotFound from '../NotFound';

import DynamicComponent from '../../DynamicComponent';

const Ads = ({ data, isLast }) => (
	<StyledKeywords>
		<section>
			<h2>{data.title}</h2>
			<p>{data.content.text}</p>
		</section>

		{
			(data.tables.length > 0) ? (
				<div className="content-1200">
					<div className="content-charts">
						{data.tables.map(
							table => <DynamicComponent tag={table.type} data={table.data} keys={table.keys} />,
						)
						}
					</div>
				</div>
			) : (
				<section className="mt-4">
					<NotFound />
				</section>
				)
		}

		{!isLast ? <hr className="mt-4" /> : null}
	</StyledKeywords>
);

export default Ads;
